import { render, staticRenderFns } from "./hk4.vue?vue&type=template&id=fee071b2"
import script from "./hk4.vue?vue&type=script&lang=js"
export * from "./hk4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports